import api from './api';

export const reportService = {
  generateMonthlyInvoice: async (projectCode, year, month, format = 'json') => {
    const response = await api.post('/reports/monthly-invoice', {
      project_code: projectCode,
      year,
      month,
      format,
    }, {
      responseType: format === 'json' ? 'json' : 'blob',
    });

    if (format === 'pdf' || format === 'excel') {
      // Create download link for binary data
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const extension = format === 'pdf' ? 'pdf' : 'xlsx';
      link.setAttribute('download', `invoice_${projectCode}_${year}_${month}.${extension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      return { success: true };
    }

    return response.data;
  },

  generateMonthRangeReport: async (projectCode, startMonth, endMonth) => {
    const response = await api.post('/reports/month-range', {
      project_code: projectCode,
      start_month: startMonth,
      end_month: endMonth,
    });
    return response.data;
  },
};
